function w(e) {
  return typeof e == "function";
}
function A(e) {
  return e == null ? e === void 0 ? "[object Undefined]" : "[object Null]" : toString.call(e);
}
function S(e) {
  return typeof e == "object" && e !== null;
}
function I(e) {
  return typeof e == "number" || S(e) && A(e) === "[object Number]";
}
function N(e) {
  const r = e.match(/{\s*[\w\.]+\s*}/g);
  return r !== null ? r.map((n) => {
    const t = n.match(/[\w\.]+/);
    return t ? t[0] : "";
  }).filter((n) => n !== "") : [];
}
function T(e, r) {
  let n = e;
  return Object.keys(r).forEach((t) => {
    n = n.replace(new RegExp(`{${t}}`, "g"), `${r[t]}`);
  }), n;
}
function _(e) {
  return e === null;
}
function g(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
function m(e, r) {
  const n = e.split(".");
  if (n.length === 1)
    return e in r ? r[e] : null;
  const t = n.reduce((c, i) => _(c) ? null : g(c) && i in c ? c[i] : null, r);
  return g(t) ? null : t;
}
function C(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var K = function(r) {
  return $(r) && !P(r);
};
function $(e) {
  return !!e && typeof e == "object";
}
function P(e) {
  var r = Object.prototype.toString.call(e);
  return r === "[object RegExp]" || r === "[object Date]" || F(e);
}
var U = typeof Symbol == "function" && Symbol.for, v = U ? Symbol.for("react.element") : 60103;
function F(e) {
  return e.$$typeof === v;
}
function R(e) {
  return Array.isArray(e) ? [] : {};
}
function s(e, r) {
  return r.clone !== !1 && r.isMergeableObject(e) ? o(R(e), e, r) : e;
}
function V(e, r, n) {
  return e.concat(r).map(function(t) {
    return s(t, n);
  });
}
function H(e, r) {
  if (!r.customMerge)
    return o;
  var n = r.customMerge(e);
  return typeof n == "function" ? n : o;
}
function x(e) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(r) {
    return Object.propertyIsEnumerable.call(e, r);
  }) : [];
}
function j(e) {
  return Object.keys(e).concat(x(e));
}
function d(e, r) {
  try {
    return r in e;
  } catch {
    return !1;
  }
}
function L(e, r) {
  return d(e, r) && !(Object.hasOwnProperty.call(e, r) && Object.propertyIsEnumerable.call(e, r));
}
function D(e, r, n) {
  var t = {};
  return n.isMergeableObject(e) && j(e).forEach(function(c) {
    t[c] = s(e[c], n);
  }), j(r).forEach(function(c) {
    L(e, c) || (d(e, c) && n.isMergeableObject(r[c]) ? t[c] = H(c, n)(e[c], r[c], n) : t[c] = s(r[c], n));
  }), t;
}
function o(e, r, n) {
  n = n || {}, n.arrayMerge = n.arrayMerge || V, n.isMergeableObject = n.isMergeableObject || K, n.cloneUnlessOtherwiseSpecified = s;
  var t = Array.isArray(r), c = Array.isArray(e), i = t === c;
  return i ? t ? n.arrayMerge(e, r, n) : D(e, r, n) : s(r, n);
}
o.all = function(r, n) {
  if (!Array.isArray(r))
    throw new Error("first argument should be an array");
  return r.reduce(function(t, c) {
    return o(t, c, n);
  }, {});
};
var W = o, Y = W;
const B = /* @__PURE__ */ C(Y);
function q(e) {
  return e === 0 ? "many" : e === 1 ? "one" : "many";
}
function z(e, r) {
  return `${e}__${q(r)}`;
}
function G(e) {
  const r = e.countKey || "n", n = e.cache || /* @__PURE__ */ new Map();
  let t = e.translations;
  const c = !!e.loggingEnabled;
  function i(u) {
    t = B(t, u), n.clear();
  }
  function b(u, l) {
    const a = n.get(u);
    return {
      key: u,
      value: w(a) ? a(l ?? {}) : a,
      cacheHit: !0
    };
  }
  function h(u, l) {
    if (l && r in l && I(l[r])) {
      const a = z(u, l[r]);
      if (n.has(a))
        return b(a);
      const f = m(a, t);
      if (f)
        return {
          key: a,
          value: f,
          cacheHit: !1
        };
    }
    return n.has(u) ? b(u, l) : { key: u, value: m(u, t), cacheHit: !1 };
  }
  function O(u, l) {
    const { key: a, value: f, cacheHit: E } = h(u, l);
    if (E)
      return f;
    if (f) {
      if (l && N(f).length > 0) {
        const y = (M) => T(f, M);
        return n.set(a, y), y(l);
      }
      return n.set(a, f), f;
    }
    return p(`No translation was found for key '${a}'.`), a;
  }
  function p(u) {
    c && console.warn(`[i17n warn]: ${u}`);
  }
  return {
    t: O,
    extend: i
  };
}
export {
  G as createI17n
};
